import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "../../../store/CategoriesSlice";
import { categoryProducts ,MoveTo_cat_} from "../../../store/productsSlice";
import Swal from "sweetalert2";
import { SwToast } from "../../../lib/SwAlert";
import { ClearSelectedItem } from "../../../store/productsSlice";
import { ClearSel } from "../../../store/selectedSlice";

function Categories() {
  const { categories } = useSelector((state) => state.category);
      const { selectedList } = useSelector((state) => state.select);
  
  const [IsCatSelect, setIsCatSelect] = useState(0);
  const [Move, setMove] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCategories("active"));
  }, [dispatch]);
  const List = categories ? (
    categories.map((Item, index) => (
      <option key={Item._id} value={Item.Categories_ID}>
        {Item.CatName}
      </option>
    ))
  ) : (
    <></>
  );

  const SynCat = (Cat) => {
    setIsCatSelect(Cat);
    dispatch(categoryProducts(Cat));
  };

  const SynSelectCat = () => {
    dispatch(categoryProducts(IsCatSelect));
  };
  const handleMoveProducts = (Move) => {
    if(selectedList.length <= 0 ){
      Swal.fire("تحذير هام", "يجب اختيار منتج واحد على الاقل لنقله الى الفئة الاخرى", "warning");
      return;
    }
    if (Move) {
      if(IsCatSelect === 0){
        Swal.fire("تحذير هام", "يجب اختيار فئة لنقل المنتجات اليها", "warning");
        return;
      }
      setMove(!Move);
      // console.log("Move is ",Move,IsCatSelect);
      dispatch(MoveTo_cat_(IsCatSelect));
      SwToast("success", ` 🎉  ${"تم نقل المنتجات"}`);
        dispatch(ClearSelectedItem());
              dispatch(ClearSel());
              setTimeout(() => {
              SynCat(IsCatSelect);
              }, 1500);
    }else{
      setMove(!Move);      
    }
  };
  return (
    <>
      <div
        className="AtoCalc Transition BTN_"
        title="مزامنة الفئة "
        onClick={(e) => SynSelectCat()}
      >
        <i className="fa fa-sync "></i>
      </div>
      <select
        name="Categories"
        className="round"
        title=" الفئة "
        defaultValue={0}
        onChange={(e) => SynCat(e.target.value)}
      >
        <option value="0"> حدد الفئة </option>
        {List}
      </select>

      <div onClick={() =>  handleMoveProducts(Move)  }   className="AtoCalc Transition BTN_" style={{color: Move ? "#d627f3" : "blue"}}
              title="نقل المحدد الى الفئة الاخرى"
              
            >
             <i className="fas fa-trailer"></i>
            </div>
    </>
  );
}
export default Categories;
